/**
 * Kestovar Logger — Production-safe logging utility
 * Logs are stripped in production builds. Always use this instead of console.*
 */

const IS_DEV = import.meta.env.DEV;

function formatMessage(level: string, component: string, ...args: unknown[]): string {
  return `[Kestovar][${level}][${component}]`;
}

export const logger = {
  log(component: string, ...args: unknown[]) {
    if (IS_DEV) {
      // eslint-disable-next-line no-console
      console.log(formatMessage('LOG', component), ...args);
    }
  },
  warn(component: string, ...args: unknown[]) {
    if (IS_DEV) {
       
      console.warn(formatMessage('WARN', component), ...args);
    }
  },
  error(component: string, ...args: unknown[]) {
    if (IS_DEV) {
       
      console.error(formatMessage('ERROR', component), ...args);
    }
  },
};

/** Guarded localStorage access — handles SSR, privacy mode, quota exceeded */
export const safeStorage = {
  get<T>(key: string, fallback: T): T {
    try {
      const raw = localStorage.getItem(key);
      return raw ? (JSON.parse(raw) as T) : fallback;
    } catch {
      return fallback;
    }
  },
  set<T>(key: string, value: T): boolean {
    try {
      localStorage.setItem(key, JSON.stringify(value));
      return true;
    } catch {
      return false;
    }
  },
  remove(key: string): boolean {
    try {
      localStorage.removeItem(key);
      return true;
    } catch {
      return false;
    }
  },
};
